import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Progress } from "@/components/ui/progress";

export default function Questionnaire() {
  const [qs, setQs] = useState([]);
  const [i, setI] = useState(0);
  const [answers, setAnswers] = useState({});
  const nav = useNavigate();

  useEffect(() => {
    Promise.all([api.get("/questionnaire"), api.get("/questionnaire/mine")]).then(([qres, ares]) => {
      setQs(qres.data.questions);
      setAnswers(ares.data.answers || {});
    });
  }, []);

  const q = qs[i];
  const pct = qs.length ? Math.round(((i + 1) / qs.length) * 100) : 0;

  const pick = (opt) => {
    setAnswers(a => ({ ...a, [q.id]: opt }));
    setTimeout(() => { if (i < qs.length - 1) setI(i+1); }, 200);
  };

  const submit = async () => {
    try { await api.post("/questionnaire/submit", { answers }); toast.success("Questionnaire saved"); nav("/dashboard"); }
    catch { toast.error("Save failed"); }
  };

  if (!qs.length) return <div className="max-w-2xl mx-auto px-6 py-20 text-neutral-500">Loading…</div>;

  return (
    <div className="max-w-2xl mx-auto px-6 py-16" data-testid="questionnaire-page">
      <div className="flex items-center gap-4 mb-8">
        <div className="text-eyebrow">Question {i+1} of {qs.length}</div>
        <div className="flex-1"><Progress value={pct} className="h-1.5" /></div>
      </div>
      <div className="text-eyebrow gold mb-2">{q.category}</div>
      <h1 className="font-heading text-3xl md:text-4xl leading-tight" data-testid="question-text">{q.text}</h1>
      <div className="grid gap-3 mt-10">
        {q.options.map(opt => {
          const selected = answers[q.id] === opt;
          return (
            <button key={opt} onClick={()=>pick(opt)} className={`text-left p-5 rounded-2xl border transition ${selected ? "bg-black text-white border-black" : "bg-white border-neutral-200 hover:border-black"}`} data-testid={`option-${q.id}-${opt.replace(/\s+/g, "-")}`}>
              {opt}
            </button>
          );
        })}
      </div>
      <div className="flex justify-between mt-10">
        <Button variant="outline" className="rounded-full" onClick={()=>setI(Math.max(0, i-1))} disabled={i===0} data-testid="q-prev">Back</Button>
        {i < qs.length - 1 ? (
          <Button className="rounded-full bg-black text-white btn-pill" onClick={()=>setI(i+1)} disabled={!answers[q.id]} data-testid="q-next">Next</Button>
        ) : (
          <Button className="rounded-full bg-black text-white btn-pill" onClick={submit} disabled={Object.keys(answers).length < qs.length} data-testid="q-submit">Finish</Button>
        )}
      </div>
    </div>
  );
}
